import React from 'react'
import { Link } from 'gatsby'
import { Link as MaterialLink, Container, Typography, Grid, useTheme, Box } from '@mui/material'
import emailLogo from '../images/close-envelope.png'
import facebookLogo from '../images/facebook-logo.png'
import linkedinLogo from '../images/linkedin-logo.png'
import MailChimp from './mailchimp'

const Footer = () => {
	const theme = useTheme()

	return (
		<Box sx={{ backgroundColor: theme.palette.primary.light, pt: 5 }} id='footer'>
			<Container maxWidth='md'>
				<Grid container spacing={8}>
					<Grid item xs={12} md={4}>
						<Typography variant='h6'>Contact us</Typography>
						<Typography>Mbuburu</Typography>
						<Typography>Lengakiki, West Honiara, Solomon Islands</Typography>
						<Typography>+677 20453</Typography>
						<Box sx={{ py: '10px' }}>
							<MaterialLink
								href='mailto:enquiry@pasifikihr.com'
								target='_blank'
								rel='noopener noreferrer'
								sx={{ mr: '10px' }}
							>
								<Box src={emailLogo} height='24px' alt='email' component='img' />
							</MaterialLink>
							<MaterialLink
								href='https://www.facebook.com/pasifikifindimwaka/'
								target='_blank'
								rel='noopener noreferrer'
								sx={{ mr: '10px' }}
							>
								<Box src={facebookLogo} height='24px' alt='facebook' component='img' />
							</MaterialLink>
							<MaterialLink
								href='https://www.linkedin.com/company/pasifiki-services-ltd/'
								target='_blank'
								rel='noopener noreferrer'
							>
								<Box src={linkedinLogo} height='24px' alt='linkedin' component='img' />
							</MaterialLink>
						</Box>
					</Grid>
					<Grid item xs={12} md={4}>
						<Box>
							<Typography color='textPrimary' variant='h6'>
								Newsletter
							</Typography>
							<Typography color='textPrimary'>
								Subscribe to our weekly newsletter to get the latest jobs and stay updated.
							</Typography>
							<MailChimp />
						</Box>
					</Grid>
					<Grid item xs={12} md={4}>
						<Box>
							<Typography color='textPrimary' variant='h6'>
								Support
							</Typography>
							<Typography color='textPrimary'>Career Guide was supported by the Australian Government</Typography>
						</Box>
					</Grid>
					<Grid item xs={12} sx={{ p: 4 }}>
						<Typography variant='body2'>
							Read our{' '}
							<Link to='/terms' style={{ color: theme.palette.secondary.main, textDecoration: 'none' }}>
								Terms & Conditions
							</Link>{' '}
							and{' '}
							<Link to='/privacy' style={{ color: theme.palette.secondary.main, textDecoration: 'none' }}>
								Privacy Policy
							</Link>
							.
						</Typography>
					</Grid>
				</Grid>
			</Container>
		</Box>
	)
}

export default Footer
